import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH3Block,
  createH4Block,
  createPBlock,
  createUlBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderColorOptions } from "../../../utils/buttonStyleHelpers";
import { getSalesBlockPrimaryStyleOptions } from "../../Sales/constants";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "CardCallToAction",
  props: {
    highlight: {
      prop: "other",
      type: "string",
      value: "",
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
        }),
        createH3Block({
          text: "1:1 Executive Coaching",
        }),
        createH4Block({
          text: "Get a custom leadership roadmap tailored to YOUR career goals",
        }),
        createUlBlock({
          items: [
            "Step-by-step coaching delivers measurable results in 90 days",
            "Strategic frameworks used by Fortune 500 executives",
            "Bi-weekly accountability check-ins to ensure progress",
          ],
        }),
        createPBlock({
          text: "Only 5 spots available this month",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockPrimaryStyleOptions(),
        borderColor: getBorderColorOptions({
          defaultValue: "var(--theme-website-color-border-primary)",
        }),
      },
    },
  },
};
